import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=22bf59d2"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=22bf59d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports